export const collator = new Intl.Collator("en");

export const MAX_COLUMN_AMOUNT = 50;
